import DopeUI, { TERMINAL } from '../ui/DopeOS-UI';
import { DopeTextRenderer } from '../renderer/bitmapFont';

function text(ctx, value, x, y, color = TERMINAL.TEXT) {
  ctx.fillStyle = color;
  DopeTextRenderer.renderDOSText(ctx, value, x, y, 1);
}

function hit(list, id, x, y, w, h, onClick) {
  list.push({ id, x, y, w, h, onClick });
}

function money(value) {
  return value?.amount == null ? '--' : `$${value.amount}`;
}

export function drawTradeDialog(ctx, screen, asset, state, quote, actions) {
  const hits = [];
  const w = Math.min(424, screen.width - 16);
  const h = Math.min(312, screen.height - 16);
  const x = Math.floor((screen.width - w) / 2);
  const y = Math.floor((screen.height - h) / 2);

  ctx.save();
  ctx.globalAlpha = 0.78;
  ctx.fillStyle = TERMINAL.BLACK;
  ctx.fillRect(0, 0, screen.width, screen.height);
  ctx.restore();

  DopeUI.Panel(ctx, x, y, w, h, `TRADE TICKET // ${asset.name}`);
  const innerX = x + 14;
  let cursorY = y + 30;

  const sideY = cursorY;
  const sideW = 140;
  DopeUI.Button(ctx, innerX, sideY, sideW, 24, 'BUY', state.side === 'BUY' ? 'hover' : 'normal');
  DopeUI.Button(ctx, innerX + sideW + 8, sideY, sideW, 24, 'SELL', state.side === 'SELL' ? 'hover' : 'normal');
  hit(hits, 'trade-side-buy', innerX, sideY, sideW, 24, () => actions.side('BUY'));
  hit(hits, 'trade-side-sell', innerX + sideW + 8, sideY, sideW, 24, () => actions.side('SELL'));

  cursorY += 38;
  text(ctx, 'QUANTITY', innerX, cursorY, TERMINAL.TEXT_DIM);
  const qtyY = cursorY + 16;
  DopeUI.Button(ctx, innerX, qtyY, 54, 26, '[-]', 'normal');
  ctx.fillStyle = TERMINAL.BLACK;
  ctx.fillRect(innerX + 62, qtyY, 100, 26);
  ctx.strokeStyle = TERMINAL.GREEN;
  ctx.strokeRect(innerX + 62, qtyY, 100, 26);
  text(ctx, String(state.qty).padStart(2, '0'), innerX + 94, qtyY + 4, TERMINAL.TEXT_BRIGHT);
  DopeUI.Button(ctx, innerX + 170, qtyY, 54, 26, '[+]', 'normal');
  hit(hits, 'trade-qty-dec', innerX, qtyY, 54, 26, actions.dec);
  hit(hits, 'trade-qty-inc', innerX + 170, qtyY, 54, 26, actions.inc);

  cursorY += 58;
  const rows = [
    ['UNIT PRICE', money(quote?.unitPrice)],
    ['SETTLEMENT', money(quote?.total)],
    ['HEAT', quote ? `+${quote.heatDelta ?? 0}` : '--'],
    ['CASH AFTER', money(quote?.cashAfter)],
    ['COAT AFTER', quote ? `${quote.inventoryAfter ?? '--'}/${quote.capacity ?? '--'}` : '--/--'],
  ];
  rows.forEach(([label, value]) => {
    text(ctx, label, innerX, cursorY, TERMINAL.TEXT_DIM);
    text(ctx, value, innerX + 160, cursorY, TERMINAL.TEXT_BRIGHT);
    cursorY += 17;
  });

  const disabled = quote?.disabledReasons?.[0];
  const message = state.error
    ? state.error
    : disabled
      ? disabled.message.toUpperCase()
      : state.receipt?.detail
        ? state.receipt.detail
        : 'PRICE LOCKED';
  ctx.fillStyle = state.error || disabled ? TERMINAL.GREEN_DARKEST : TERMINAL.BLACK;
  ctx.fillRect(innerX, cursorY + 2, w - 28, 20);
  text(ctx, message.slice(0, 48), innerX + 6, cursorY + 5, state.error || disabled ? TERMINAL.TEXT_BRIGHT : TERMINAL.TEXT_DIM);

  const actionY = y + h - 36;
  DopeUI.Button(ctx, innerX, actionY, 132, 24, 'CANCEL', 'normal');
  const canExecute = !!quote?.canExecute && !state.loading;
  DopeUI.Button(ctx, x + w - 164, actionY, 136, 24, state.loading ? 'EXECUTING' : 'EXECUTE', canExecute ? 'hover' : 'disabled');
  hit(hits, 'trade-cancel', innerX, actionY, 132, 24, actions.cancel);
  if (canExecute) hit(hits, 'trade-execute', x + w - 164, actionY, 136, 24, actions.execute);

  return hits;
}

export default drawTradeDialog;
